import React from 'react';
import Layout from '../../Layout';
import { useWindowResizeEffect } from '../../hooks/resizeHeight';
import Disclaimer from '../../components/disclaimer';
import { useNavigate } from 'react-router-dom';

const CampaignRegulations = () => {
  const height = useWindowResizeEffect();
  const navigate = useNavigate();

  const regulations = [
    {
      id: 1,
      image: '/images/promotiile/promotii_desktop_promotia.png',
      link: '/promotia',
    },
    {
      id: 2,
      image: '/images/promotiile/promotii_desktop_lidl.png',
      link: 'https://lidl.caraiman.ro',
    },
  ];

  const handleRegulationClick = (link: string) => {
    if (link.startsWith("http")) {
      window.location.href = link;
    } else {
      navigate(link);
    }
  };

  return (
    <Layout>
      <div
        className="flex flex-col items-center justify-center w-full bg-cover bg-center bg-no-repeat z-1 pb-6"
        style={{
          backgroundImage:
            "url('/images/povestile/Caraiman_povestile_background.png')",
          minHeight: height + 20,
        }}
      >
        <div className="w-full max-w-6xl mx-4 mb-8 mt-20 lg:mt-0">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {regulations.map((regulation) => (
              <button
                key={regulation.id}
                onClick={() => handleRegulationClick(regulation.link)}
                className="cursor-pointer transform hover:scale-105 transition-transform duration-300 bg-transparent border-none p-0 w-full"
              >
                <img
                  src={regulation.image}
                  alt="Regulament promoție"
                  className="w-full h-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 px-4"
                  onError={(e) => {
                    e.currentTarget.src = '/images/icons2.png';
                  }}
                />
              </button>
            ))}
          </div>
        </div>

        <button
          onClick={() => navigate('/regulament-promotie')}
          className="fixed bottom-12 lg:bottom-8 bg-button-green text-secondary-grey font-semibold text-2xl rounded px-5 py-3 text-nowrap"
        >
          REGULAMENTE PROMOȚII
        </button>
      </div>
      <Disclaimer
        textColor="text-secondary-grey-light"
        shadow="tail-shadow"
        image="/images/icons2.png"
      />
    </Layout>
  );
};

export default CampaignRegulations;
